import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"
import extend from "extend";
import $ from "jquery";

export default class WishlistController extends React.Component {
    constructor(props) {
        super(props);
        this.state = { feedback: null };

        this.addToWishlist = this.addToWishlist.bind(this);
        this.removeFromWishlist = this.removeFromWishlist.bind(this);
        this.clearFeedback = this.clearFeedback.bind(this);
    }

    addToWishlist(event) {
        if (this.props.authenticated) {
            event.preventDefault();
            $.ajax(this.props.addUrl, {
                method: "POST",
                data: {
                    productId: this.props.product.id,
                },
                success: (data) => {
                    this.setState({ feedback: data });
                    this.props.onChange(extend(true, {}, this.props.product, { onWishlist: true }));
                },
                dataType: "json",
            });
        }
    }
    removeFromWishlist(event) {
        event.preventDefault();
        $.ajax(this.props.removeUrl, {
            method: "POST",
            data: {
                productId: this.props.product.id,
            },
            success: (data) => {
                this.setState({ feedback: data });
                this.props.onChange(extend(true, {}, this.props.product, { onWishlist: false }));
            },
            dataType: "json",
        });
    }
    clearFeedback(event) {
        event.preventDefault();
        this.setState({ feedback: null });
    }
    render() {
        const WishlistView = ComponentRegistry.get(this.props.view);

        return (
          <WishlistView
            {...this.props}
            {...this.state}
            onAdd={this.addToWishlist}
            onRemove={this.removeFromWishlist}
            onClearFeedback={this.clearFeedback}
          />
        );
    }
}

WishlistController.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
    addUrl: PropTypes.string.isRequired,
    removeUrl: PropTypes.string.isRequired,
    authenticated: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    view: PropTypes.string.isRequired,
};

WishlistController.defaultProps = {
    view: "ProductPurchaseViewsWishlistView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductPurchase/Controllers/WishlistController.jsx